import styled, { css } from 'styled-components';
import { device } from '@styles/mediaQuery';

type StatItemProps = {
  title: string;
  subtitle: string;
};

function StatItem({ title, subtitle }: StatItemProps) {
  return (
    <Wrapper>
      <Title>{title}</Title>

      <Subtitle>{subtitle}</Subtitle>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  margin-top: 5px;

  width: 33%;
  height: 65px;

  &:first-child {
    margin-left: 5px;
    align-items: flex-start;
  }

  &:last-child {
    align-items: flex-end;
  }

  ${device.tablet(css`
    height: 130px;
    margin-top: 30px;
  `)};
`;

const Title = styled.div`
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: 36px;
  font-weight: 600;
  width: 80px;

  ${device.tablet(css`
    width: 100px;
    font-size: 48px;
  `)};
`;

const Subtitle = styled.div`
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 12px;
  width: 80px;

  ${device.tablet(css`
    width: 100px;
    font-size: 16px;
  `)};
`;

export default StatItem;
